interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) {
    return null;
  }

  const pages = Array.from({ length: total }, (_, i) => i + 1);

  return (
    <div className="mt-10 flex items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="flex h-10 cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300/60 px-4 text-sm text-foreground-800 transition-colors hover:border-primary-500/60 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
        上一页
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`h-10 w-10 cursor-pointer rounded-md text-sm font-medium transition-colors ${
            page === current
              ? "bg-accent-500 text-background-950"
              : "border border-background-300/60 text-foreground-700 hover:border-primary-500/60"
          }`}
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className="flex h-10 cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300/60 px-4 text-sm text-foreground-800 transition-colors hover:border-primary-500/60 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </div>
  );
}